export default __webpack_public_path__ + "static/media/csa.16da6fba.png";